import { OccupancyRateFiltersState, OccupancyRateFiltersActionTypes, READ_OCCUPANCY_RATE_FILTERS_REQUEST, READ_OCCUPANCY_RATE_FILTERS_SUCCESS, READ_OCCUPANCY_RATE_FILTERS_FAILURE } from "store/reducers/room/readOccupancyRateFilters/types";

const defaultState: OccupancyRateFiltersState = {
  isLoading: false,
  errorMessage: ""
};

export default function occupancyRate(state = defaultState, action: OccupancyRateFiltersActionTypes): OccupancyRateFiltersState {
  switch (action.type) {
    case READ_OCCUPANCY_RATE_FILTERS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_OCCUPANCY_RATE_FILTERS_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_OCCUPANCY_RATE_FILTERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};